import React from 'react'

import { LntTag } from '@app/components/base'

import { MONITORING_STATUS } from '@app/api/constants'

import { getTagConfigMonitoringStatus } from '../util'

import type { ObjectValuesType } from '@app/types'

export const MonitoringListStatusTagRender: React.FC<{ status: ObjectValuesType<typeof MONITORING_STATUS> }> = ({
  status
}) => {
  const config = getTagConfigMonitoringStatus(status)

  return <LntTag type={ config.type }>{ config.label }</LntTag>
}
